import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  home: defineAsyncComponent(() => import("/vercel/path0/layouts/home.vue").then(m => m.default || m))
}